import type { Nullable } from '../types';

export const safeJsonParse = <T>(str?: Nullable<string>): Nullable<T> => {
    try {
        if (!str) {
            return undefined;
        }

        const jsonValue: T = JSON.parse(str);

        return jsonValue;
    } catch {
        return undefined;
    }
};
